
import 'reflect-metadata';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class InlineGridField extends Vue {
  // PROPS
  @Prop({ required: true })
  private readonly row: any;

  @Prop({ required: true })
  private readonly column: any;

  @Prop({ required: true })
  private readonly fieldId: string;

  @Prop({ default: undefined })
  private readonly valueField: string;

  @Prop({ default: '' })
  private readonly backup: string;

  @Prop({ default: 1 })
  private readonly sizeClass: number;

  @Prop({ default: 0 })
  private readonly onOpenTrigger: number;

  // COMPUTED
  private get selectValue(): string {
    const value = this.column.valueField ?
      this.row[this.column.valueField] :
      this.row[this.column.value];

    return value;
  }

  // WATCH
  @Watch('onOpenTrigger')
  private dialogOnOpen() {
    this.addNotFlatDialogClass();
  }

  // LIFECYCLE
  private mounted() {
    this.addNotFlatDialogClass();
  }

  // METHODS
  private isColumnText(column: any): boolean {
    switch (column.type) {
      case 'time':
      case 'text':
      case 'number':
        return true;
      default:
        return false;
    }
  }

  private onTabPress($event) {
    const { value } = $event.target;

    // Se shift está pressionado...
    if ($event.shiftKey) {
      this.$emit('shiftTab', value);
    } else {
      this.$emit('tab', value);
    }
  }

  private onArrowUpPress($event) {
    this.$emit('arrowUp', $event.target.value);
  }

  private onArrowDownPress($event) {
    this.$emit('arrowDown', $event.target.value);
  }

  private addNotFlatDialogClass() {
    if (this.column.type === 'select') {
      const editDialog = this.$el.closest('.v-small-dialog__menu-content');

      editDialog.classList.add('v-small-dialog__menu-content--select');
    }
  }
}
